import { Component, OnDestroy,Renderer2 } from '@angular/core';
import { navItems } from './../../_nav';
import { RouterManagerService } from '../../service/managers/router-manager.service';
import { StorageService } from '../../service/managers/storage.service';
import { Router } from '@angular/router';
import { NotifierService } from '../../service/component_dependent/notifier.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnDestroy {

  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  private user_id = "";
  
  constructor(private routerManager: RouterManagerService, private storageService: StorageService,
    private renderer: Renderer2,
    private router: Router, private notifierService: NotifierService) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });

    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  ngOnInit(){
    const user = this.storageService.getUser();
    this.user_id = user['id'];
  }

  showBase:boolean = false
  minimize:boolean = false
  showVoice:boolean = false
  showSms:boolean = false
  showEmail:boolean = false

  toggle(){
    this.showBase = !this.showBase
  }


  toggleVoice(){
    this.showVoice = !this.showVoice
  }

  toggleEmail(){
    this.showEmail = !this.showEmail
  }

  toggleSms(){
    this.showSms = !this.showSms
  }

  miniBody(){
    this.minimize = !this.minimize

    if(this.minimize){
      this.renderer.addClass(document.body,'sidebar-minimized')
      this.renderer.addClass(document.body,'brand-minimized')
    }else{
      this.renderer.removeClass(document.body,'sidebar-minimized')
      this.renderer.removeClass(document.body,'brand-minimized')
    }

  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }

  protected logout() {
    this.storageService.clearLocalStorage();
    this.router.navigateByUrl("/login");
  }

}
